<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function () {
  function isCollectionPage() {
    return document.body.classList.contains("template-collection") ||
      location.pathname.includes("/collections/");
  }

  function dedupeProductColors() {
    if (!isCollectionPage()) return;

    document.querySelectorAll(".product-colors").forEach((wrap) => {
      const items = Array.from(wrap.children);
      if (items.length < 2) return;

      const seen = new Set();

      items.forEach((el) => {
        // ✅ clé = HTML identique (ton Test 1)
        const key = el.outerHTML.replace(/\s+/g, " ").trim();

        if (seen.has(key)) el.remove();
        else seen.add(key);
      });
    });
  }

  // Debounce: évite de relancer 50 fois quand la grille bouge
  let t = null;
  function scheduleDedupe() {
    clearTimeout(t);
    t = setTimeout(dedupeProductColors, 60);
  }

  function initObserver() {
    if (!isCollectionPage()) return;

    // cible la grille produits (Halo varie selon les templates)
    const grid =
      document.querySelector("#main-collection-product-grid") ||
      document.querySelector("#CollectionProductGrid") ||
      document.querySelector("[data-products-grid]") ||
      document.querySelector(".productGrid") ||
      document.querySelector("main");

    if (!grid) return;

    // 1) run initial + quelques passes (scripts tardifs)
    dedupeProductColors();
    setTimeout(dedupeProductColors, 150);
    setTimeout(dedupeProductColors, 600);
    setTimeout(dedupeProductColors, 1200);

    // 2) observe tout changement DOM dans la grille
    const obs = new MutationObserver((mutations) => {
      // optimisation : ne réagit que si on touche aux swatches / cartes
      for (const m of mutations) {
        if (m.type === "childList" && (m.addedNodes.length || m.removedNodes.length)) {
          scheduleDedupe();
          break;
        }
      }
    });

    obs.observe(grid, { childList: true, subtree: true });

    // 3) au cas où une navigation AJAX / tri déclenche après load
    window.addEventListener("load", () => {
      dedupeProductColors();
      setTimeout(dedupeProductColors, 300);
    });
  }

  document.addEventListener("DOMContentLoaded", initObserver);
})();